// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3_5Xb","loaderOuter":"PageOverlayLoader_loaderOuter__BHuRq"};